// extracted by mini-css-extract-plugin
module.exports = {"footer":"layout-module--footer--iPB_d","twitterLink":"layout-module--twitterLink--1UmyT","fabContainer":"layout-module--fab-container--3Mump"};